import { FaFacebookF, FaInstagram, FaWhatsapp, FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaTiktok } from 'react-icons/fa';
import { Link } from 'react-router-dom';


function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">

        {/* COLUMNA 1 - EMPRESA */}
        <div className="footer-col">
          <h3>Viajeros Explorando Perú</h3>
          <p>
            Descubre los destinos más increíbles del Perú con experiencias únicas,
            seguras y personalizadas.
          </p>
        </div>

        {/* COLUMNA 2 - ENLACES */}
        <div className="footer-col">
          <h4>Enlaces</h4>
          <ul>
            <li><Link to="/">Inicio</Link></li>
            <li><Link to="/destinos">Destinos</Link></li>
            <li><Link to="/nosotros">Nosotros</Link></li>
            <li><Link to="/contacto">Contacto</Link></li>
          </ul>
        </div>

        {/* COLUMNA 3 - CONTACTO */}
        <div className="footer-col">
          <h4>Contacto</h4>
          <p><FaMapMarkerAlt /> Lima, Perú</p>
          <p><FaPhoneAlt /> +51 935 438 935</p>
          <p><FaPhoneAlt /> +51 970 159 538</p>
          <p><FaEnvelope /> viajerosexplorandoperu@gmail.com</p>
        </div>

        {/* COLUMNA 4 - REDES */}
        <div className="footer-col ">
          <h4 className="footer-siguenos">Síguenos</h4>
          <div className="footer-socials">
            <a href="https://www.facebook.com/share/1C42PPhtXT/?mibextid=wwXIfr"  target="_blank" rel="noopener noreferrer"
            ><FaFacebookF />
           </a>

          <a href="https://www.instagram.com/viajeros_explorando_peru?igsh=MXR2ZHZodDI0d3Nqbw%3D%3D&utm_source=qr" target="_blank" rel="noopener noreferrer"
            ><FaInstagram />
          </a>
         
         <a href="https://wa.me/51935438935?text=Vengo%20de%20la%20p%C3%A1gina%2C%20deseo%20m%C3%A1s%20informaci%C3%B3n." target="_blank" rel="noopener noreferrer"
            ><FaWhatsapp />
         </a>

         <a href="https://www.tiktok.com/@viajerosexplorandoperu" target="_blank" rel="noopener noreferrer"
            ><FaTiktok />
         </a>

         </div>
        </div> 

      </div>



      <div className="footer-bottom">
        © {new Date().getFullYear()} Viajeros Explorando Perú — Todos los derechos reservados.
      </div>
    </footer>
  );
}

export default Footer;
